import React from 'react';
import { motion } from 'framer-motion';
export function StatsRow() {
  return <section className="relative bg-[#1A1A1A] py-16 border-b border-[#252525]" data-id="element-351">
      {/* Heavy timber texture */}
      <div className="absolute inset-0 texture-timber opacity-40" data-id="element-352" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-353">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center text-center" data-id="element-354">
          <span className="text-3xl md:text-4xl font-serif font-bold text-[#F5F3F0] mb-2" data-id="element-355">
            30+ Years
          </span>
          <span className="text-sm uppercase tracking-widest text-[#A07656] font-medium" data-id="element-356">
            Collective Experience
          </span>
        </motion.div>
      </div>
    </section>;
}